/**
 * @copyright Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React from 'react';
import {
    Navigate,
    Route,
    Routes
} from 'react-router-dom';

import HomeRouter from './home/HomeRouter.jsx';
import ExploreRouter from './explore/ExploreRouter.jsx';
import ListsRouter from './lists/ListsRouter.jsx';
import IntegrationsRouter from './manage/integrations/IntegrationsRouter';
import TeamRouter from './manage/team/TeamRouter';


export default function OrganizationRouter() {
    return (
            <Routes>
                <Route path="/org/home/*" element={<HomeRouter/>}/>
                <Route path="/org/explore/*" element={<ExploreRouter/>}/>
                <Route path="/org/lists/*" element={<ListsRouter/>}/>
                {/*<Route path="/org/manage/integrations" element={<IntegrationsRouter/>}/>*/}
                <Route path="/org/manage/team/*" element={<TeamRouter/>}/>
                <Route path="/org" element={<Navigate to="/org/home" replace/>}/>
            </Routes>
        );
}
